import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { AssessmentResult } from '../entities/AssessmentResult'

@InputType()
export class UpdateStudentAnswerArgs extends ActionArgs {
  @Field(() => ID)
  resultId: string

  @Field(() => Float)
  questionNumber: number

  @Field(() => String, { nullable: true })
  extractedAnswer?: string

  @Field(() => Boolean, { nullable: true })
  isCorrect?: boolean

  @Field(() => String, { nullable: true })
  remarks?: string

  @Field(() => Float, { nullable: true })
  awardedPoints?: number

  // Clears the manual override on the target answer so the score recompute re-grades it from the
  // answer key (shared compareAnswers) instead of honoring a client-supplied isCorrect. When set,
  // extractedAnswer/isCorrect are ignored.
  @Field(() => Boolean, { nullable: true })
  resetToAuto?: boolean
}

export interface IUpdateStudentAnswer extends IAction<AssessmentResult, UpdateStudentAnswerArgs> {}
